import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { AdvisorId, ClientId, LiquidationId, PhysicalAccountId, TaskId, } from "../../Types";
import ValidationError from "../../ZodError";
import { Amount, LiquidationStatus } from "../Types";
export const liquidationsUrl = () => environment() === "PROD"
    ? "https://middleware.prod.farther.com/liquidation/v1/liquidations"
    : "https://middleware.uat.farther.com/liquidation/v1/liquidations";
export const PostLiquidationRequest = z.object({
    clientId: ClientId,
    advisorId: AdvisorId,
    physicalAccountId: PhysicalAccountId,
    liquidationAmount: Amount,
    requestDate: z.string().datetime({ offset: true }),
});
export const PostLiquidationResponse = z.object({
    liquidationId: LiquidationId,
    liquidationStatus: LiquidationStatus,
    physicalAccountId: PhysicalAccountId,
    liquidationAmount: Amount,
    requestDate: z.string().datetime({ offset: true }),
    taskId: TaskId,
    createdTs: z.string().datetime(),
    updatedTs: z.string().datetime(),
});
export default async function postLiquidation(request, config) {
    const { data } = await axios.post(liquidationsUrl(), PostLiquidationRequest.parse(request), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Client: config.clientId,
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
    const decoded = PostLiquidationResponse.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[postLiquidation] returned unexpected data.";
        errorLog(postLiquidation.name, JSON.stringify(decoded.error.issues));
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=postLiquidation.js.map